<div class="container-capped" *ngIf="resource">
	<form #form="ngForm" (submit)="form.valid && save()">
		<div class="text-left p-2 white-bg border-bottom sticky">
			<button type="submit" class="btn btn-primary">ذخیره</button>
		</div>
		<div class="kp-form-row kp-required">
			<label>
				<h6>عنوان</h6>
				<input type="text" name="title" [(ngModel)]="resource.Title" required />
			</label>
		</div>
		<div class="kp-form-row kp-required">
			<label>
				<h6>نوع فایل</h6>
				<select name="type" [(ngModel)]="resource.Type" required>
					<option [ngValue]="null">نامشخص</option>
					<option [ngValue]="type" *ngFor="let type of types">{{type|readable:'resourceType'}}</option>
				</select>
			</label>
		</div>
		<div class="kp-form-row kp-required">
			<label>
				<h6>وضعیت انتشار</h6>
				<select name="status" [(ngModel)]="resource.Status" required>
					<option [ngValue]="ResourceStatus.Pending">{{ResourceStatus.Pending|readable:'resourceStatus'}}</option>
					<option [ngValue]="ResourceStatus.Published">{{ResourceStatus.Published|readable:'resourceStatus'}}</option>
					<option [ngValue]="ResourceStatus.Rejected">{{ResourceStatus.Rejected|readable:'resourceStatus'}}</option>
					<option [ngValue]="ResourceStatus.Paused">{{ResourceStatus.Paused|readable:'resourceStatus'}}</option>
					<option [ngValue]="ResourceStatus.Finished">{{ResourceStatus.Finished|readable:'resourceStatus'}}</option>
					<option [ngValue]="ResourceStatus.Archived">{{ResourceStatus.Archived|readable:'resourceStatus'}}</option>
				</select>
			</label>
		</div>
		<div class="kp-form-row kp-required">
			<label>
				<h6>قیمت</h6>
				<input type="number" name="price" [(ngModel)]="resource.Price" required />
			</label>
		</div>
		<div class="kp-form-row">
			<label>
				<h6>توضیحات کوتاه</h6>
				<textarea name="brief" [(ngModel)]="resource.Brief" rows="5" class="lh-xs"></textarea>
			</label>
		</div>
		<div class="kp-form-row ">
			<label>
				<h6>تگ‌ها</h6>
				<ng-select name="tags" [(ngModel)]="resource.Tags" [addTag]="true" [items]="tags" [multiple]="true"
					addTagText="افزودن" [selectOnTab]="true" bindLabel="Key" bindValue="Key">
					<ng-template ng-option-tmp let-item="item">
						{{item.Key}} ({{item.DocCount}})
					</ng-template>

				</ng-select>
			</label>
		</div>
		<div class="kp-form-row kp-required">
			<div>
				<h6>توضیحات</h6>
				<angular-editor placeholder="توضیحات کامل ..." name="description" [(ngModel)]="resource.Description"
					[config]="editorConfig">
				</angular-editor>
			</div>
		</div>
		<div class="kp-form-row kp-required">
			<label>
				<h6>تصویر</h6>
			</label>
			<div class="btn btn-transparent-border p-2 mr-2 d-flex" (click)="imageInput.click()" title="تصویر">
				<i class="fa fa-paperclip fs-xl"></i>انتخاب تصویر
			</div>
		</div>
		<div class="kp-form-row kp-required">
			<label>
				<h6>فایل‌ها</h6>
			</label>
			<div class="kp-card" *ngFor="let attachment of resource.Attachments;let i=index">
				<div class="d-flex justify-content-between">
					<div>{{attachment.Name}}</div>
					<div>{{attachment.Size|fileSize}}</div>
				</div>
				<div class="btn btn-red btn-sm" (click)="resource.Attachments.splice(i,1)">حذف</div>
			</div>
			<div class="kp-card" *ngFor="let file of files;let i=index">
				<div class="d-flex justify-content-between">
					<div>{{file.name}}</div>
					<div>{{file.size|fileSize}}</div>
				</div>
				<div class="btn btn-red btn-sm" (click)="files.splice(i,1)">حذف</div>
			</div>
			<div class="btn btn-transparent-border p-2 mr-2 d-flex" (click)="fileInput.click()" title="فایل">
				<i class="fa fa-paperclip fs-xl"></i>افزودن فایل
			</div>
		</div>
		<div class="text-left p-2">
			<button type="submit" class="btn btn-primary">ذخیره</button>
		</div>
	</form>
	<object-renderer [object]="resource"></object-renderer>
</div>

<input #fileInput type="file" style="display:none" (change)="onFileChange($event.target.files)" multiple>
<input #imageInput type="file" style="display:none" (change)="image=$event.target.files[0]" accept=".jpg,.jpeg,.png">